import React from 'react';
import { string, func } from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import Radium from 'radium';
import { scrollToInvalid } from '@widergy/web-utils/lib/form';
import { WithLoading } from '@widergy/energy-ui';

import { SERVICE_ADHERENCE } from 'constants/reduxForms';
import UTCheckList from 'app/components/UTCheckList';
import { message } from 'utils/stringUtils';
import { accountsPropTypes } from 'types/accountTypes';

import styles from './styles';

const header = [{ text: message('Signup:accountNumber') }, { text: message('Commons:address') }];

const ServiceAdherence = ({ onSubmit, termsOfService, accounts, accountListField }) => (
  <form onSubmit={onSubmit} style={styles.form}>
    <div style={styles.termsContainer}>
      <div
        dangerouslySetInnerHTML={termsOfService} // eslint-disable-line react/no-danger
        style={styles.terms}
      />
    </div>
    <Field
      name={accountListField}
      list={accounts}
      component={UTCheckList}
      header={header}
      checked
      withoutLabel
    />
  </form>
);

ServiceAdherence.propTypes = {
  termsOfService: string,
  onSubmit: func.isRequired,
  accounts: accountsPropTypes,
  accountListField: string
};

export default WithLoading(props => props.termsOfServiceLoading || props.acceptServiceAgreementLoading)(
  reduxForm({ form: SERVICE_ADHERENCE, onSubmitFail: errors => scrollToInvalid(errors) })(
    Radium(ServiceAdherence)
  )
);
